import React, { useRef, useCallback, useEffect } from 'react';
import { CloseIcon } from '@flexiflow-ui-kit/icon';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import styled, { css, keyframes } from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$6;
var baseModalCss = css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  :root {\n    --reach-dialog: 1;\n  }\n\n  [data-reach-dialog-overlay] {\n    background: hsla(0, 0%, 0%, 0.33);\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow: auto;\n  }\n\n  [data-reach-dialog-content] {\n    width: 50vw;\n    margin: 10vh auto;\n    background: white;\n    padding: 2rem;\n    outline: none;\n  }\n\n  & * {\n    *,\n    *::before,\n    *::after {\n      -webkit-box-sizing: border-box;\n      box-sizing: border-box;\n    }\n  }\n"])));

var _templateObject$5, _templateObject2$1, _templateObject3$1;
var ModalOverlay = styled(DialogOverlay)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  && {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 3;\n    background-color: rgba(0, 0, 0, 0.6);\n  }\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, baseModalCss);
var ModalContent = styled(DialogContent)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  && {\n    background-color: ", ";\n    padding: 24px 32px;\n    max-width: 90vw;\n    min-height: 160px;\n    min-width: 310px;\n    width: auto;\n    height: auto;\n    margin: 0;\n    z-index: 2;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    border-radius: 4px;\n  }\n"])), function (p) {
  return p.theme.palette.white;
});
var CloseButton$1 = styled.button(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  position: absolute;\n  right: 30px;\n  top: 30px;\n\n  :hover {\n    color: ", ";\n  }\n"])), function (p) {
  return p.theme.predefinedCss.buttonReset;
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['600'];
});

var ModalContext = /*#__PURE__*/React.createContext(function () {});

function Modal(_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(ModalOverlay, {
    isOpen: isOpen,
    onDismiss: onClose
  }, /*#__PURE__*/React.createElement(ModalContent, {
    "aria-label": "modal",
    className: className
  }, /*#__PURE__*/React.createElement(CloseButton$1, {
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    height: 12,
    width: 12
  })), /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: onClose
  }, children))));
}

var _templateObject$4;
var ModalBodyContainer = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 24px;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n"])));

function ModalBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(ModalBodyContainer, {
    className: className
  }, children);
}

var _templateObject$3;
var MainContainer$1 = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  width: 100%;\n  color: ", ";\n  background-color: ", ";\n  font-weight: ", ";\n  font-size: 20px;\n  line-height: 24px;\n  margin-bottom: 16px;\n"])), function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.transparent;
}, function (p) {
  return p.theme.fontWeights.bold;
});

function ModalHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(MainContainer$1, null, children);
}

var _templateObject$2, _templateObject2, _templateObject3, _templateObject4;
var slideLeft = keyframes(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(150%);\n    -webkit-transform: translateX(150%);\n  }\n  100% {\n    transform: translateX(0%);\n    -webkit-transform: translateX(0%);\n  }\n"])));
var SideModalOverlay = styled(DialogOverlay)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  && {\n    width: 384px;\n    height: 100vh;\n    z-index: 2;\n    background-color: ", ";\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    left: inherit;\n    margin: 0;\n    animation-name: ", ";\n    -webkit-animation-name: ", ";\n\n    animation-duration: 1s;\n    -webkit-animation-duration: 1s;\n\n    animation-timing-function: ease-in-out;\n    -webkit-animation-timing-function: ease-in-out;\n\n    visibility: visible !important;\n  }\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, baseModalCss, function (p) {
  return p.theme.palette.white;
}, slideLeft, slideLeft);
var SideModalContent = styled(DialogContent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  && {\n    width: 100%;\n    height: 100vh;\n    margin: 0;\n    z-index: 2;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n"])));
var CloseButton = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  position: absolute;\n  right: 30px;\n  top: 38px;\n"])), function (p) {
  return p.theme.predefinedCss.buttonReset;
}, function (p) {
  return p.theme.palette.black;
});

var SideModalContext = /*#__PURE__*/React.createContext(function () {});

function SideModal(_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      children = _ref.children,
      _ref$closeOnClickOuts = _ref.closeOnClickOutside,
      closeOnClickOutside = _ref$closeOnClickOuts === void 0 ? false : _ref$closeOnClickOuts;
  var ref = useRef(null);
  var onCloseCb = useCallback(function (evt) {
    if (!ref.current) {
      return;
    }

    if (ref.current.contains(evt.target)) {
      return;
    }

    onClose();
  }, [onClose]);
  useEffect(function () {
    if (isOpen && closeOnClickOutside) {
      document.addEventListener('mousedown', onCloseCb);
    }

    return function () {
      document.removeEventListener('mousedown', onCloseCb);
    };
  }, [onCloseCb, isOpen, closeOnClickOutside]);

  if (!isOpen) {
    return null;
  }

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(SideModalOverlay, {
    isOpen: isOpen,
    onDismiss: onClose,
    ref: ref,
    dangerouslyBypassFocusLock: true
  }, /*#__PURE__*/React.createElement(SideModalContent, {
    "aria-label": "modal",
    className: className
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    height: 12,
    width: 12
  })), /*#__PURE__*/React.createElement(SideModalContext.Provider, {
    value: onClose
  }, children))));
}

var _templateObject$1;
var SideModalBodyContainer = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 20px;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  overflow: auto;\n  margin-top: 12px;\n  padding: 8px 38px 32px 24px;\n\n  ::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n    background: ", ";\n  }\n\n  ::-webkit-scrollbar-track {\n    background-clip: border-box;\n    background-color: transparent;\n    border: 6px solid transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: 30px;\n    border: 3px solid ", ";\n  }\n"])), function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.gray['200'];
}, function (p) {
  return p.theme.palette.white;
});

function SideModalBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(SideModalBodyContainer, {
    className: className
  }, children);
}

var _templateObject;
var MainContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 20px;\n  line-height: 24px;\n  border-bottom: 1px solid ", ";\n  min-height: 108px;\n  max-height: 108px;\n  padding: 32px 48px 20px 24px;\n"])), function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.fonts.text;
}, function (p) {
  return p.theme.fontWeights.bold;
}, function (p) {
  return p.theme.palette.gray['200'];
});

function SideModalHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(MainContainer, null, children);
}

export { Modal, ModalBody, ModalHeader, SideModal, SideModalBody, SideModalHeader };
